(function () {
  var MAX_SEARCHES = 5;
  var MAX_VIEWED = 5;
  var LS_SEARCHES = 'koko_searches';
  var LS_VIEWED = 'koko_viewed';

  function saveSearch(term) {
    term = (term || '').trim().toLowerCase();
    if (term.length < 2) return;
    var list = getList(LS_SEARCHES);
    list = list.filter(function (t) { return t !== term; });
    list.unshift(term);
    localStorage.setItem(LS_SEARCHES, JSON.stringify(list.slice(0, MAX_SEARCHES)));
  }

  function saveViewed(productId) {
    if (!productId) return;
    productId = parseInt(productId);
    var list = getList(LS_VIEWED);
    list = list.filter(function (id) { return id !== productId; });
    list.unshift(productId);
    localStorage.setItem(LS_VIEWED, JSON.stringify(list.slice(0, MAX_VIEWED)));
  }

  function getList(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }

  // Capturar envíos del formulario de búsqueda
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/search"]');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (input) saveSearch(input.value);
  });

  // Capturar clicks en resultados de búsqueda predictiva
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    // Si el click viene dentro del predictive search
    if (link.closest('predictive-search, .predictive-search')) {
      var input = document.querySelector('input[name="q"]');
      if (input) saveSearch(input.value);
    }
  });

  // Registrar producto visto si estamos en página de producto
  var productIdMeta = document.querySelector('meta[name="product-id"]') ||
                      document.querySelector('[data-product-id]');
  if (productIdMeta) {
    var pid = productIdMeta.content || productIdMeta.dataset.productId;
    if (pid) saveViewed(pid);
  }
})();
